import { qualityForPath } from "./businessQuality";
import { isSensitiveRoute } from "../lib/sensitiveRoutes";

// Every one of the 69 concept pages, plus the unsolicited "/ph/why-this-matters"
// prospect page, must never be presented to search engines as an official business
// website. The safe default is noindex: a concept page is only ever indexable once its
// backend status is CONFIRMED "online_client" — the initial null (unknown) state, any
// other status, and any fetch failure all noindex. Returns null (no robots tag at all)
// for every other page, which leaves the browser default (indexable) untouched.
// Kept in its own module (no react-router-dom import anywhere in its graph) so the
// decision itself is directly unit-testable in Jest without rendering BusinessSeo.
export function robotsContentFor(pathname, status) {
  const normalized = pathname.toLowerCase().replace(/\/$/, "") || "/";

  // Private application areas — admin console, customer account portal, and PayMongo
  // checkout return pages (see src/lib/sensitiveRoutes.js, the same list AdSlot uses to
  // refuse to render ads) — must never be indexable, unconditionally and regardless of
  // business/lifecycle status. robots.txt already Disallows crawling these, but
  // Disallow alone does not guarantee removal from the index (a page can still get
  // indexed if discovered via an external link) — the explicit meta tag is the real
  // defense, matching the same lesson already applied to concept pages below.
  if (isSensitiveRoute(normalized)) {
    return "noindex, nofollow";
  }

  const businessItem = qualityForPath(pathname);
  const isWhyPage = normalized === "/ph/why-this-matters";
  if (!businessItem && !isWhyPage) return null;
  return businessItem && status === "online_client" ? "index, follow" : "noindex, nofollow";
}
